import { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import SigningFormPage from 'src/components/SigningForm/SigningFormPage';
import PrivacyPolicyPage from '../Main/PrivacyPolicy/PrivacyPolicyPage';
import JoinClassPage from './JoinClass/JoinClassPage';
import RedirectToJoinClassPage from './RedirectToJoinClassPage';
import FormPage from './StudentForms/FormPage/FormPage';
import StudentForms from './StudentForms/FormListPage/FormListPage';
import StudentWarning from './StudentWarning/StudentWarning';
import InviteSupervisorPage from './InviteSupervisor/InviteSupervisorPage';
import StudentClasses from './StudentClasses/StudentClasses';
import StudentAttendancePage from './StudentAttendance/StudentAttendancePage';
import { isAttendanceFeatureEnabled } from 'src/utils/featureFlags';

export const StudentRouter: FC = () => (
  <>
    <RedirectToJoinClassPage />
    <Routes>
      <Route
        path="/:studentUserId/form/:formId/class/:classId/assignment/:assignmentId"
        element={
          (
            <>
              <FormPage />
              <StudentWarning />
            </>
          )
        }
      />
      <Route path="/" element={<StudentClasses />} />
      <Route
        path="/forms"
        element={
          (
            <>
              <StudentForms />
              <StudentWarning />
            </>
          )
        }
      />
      <Route
        path="/class/:classId/student/:studentUserId/signingform"
        element={<SigningFormPage />}
      />
      <Route
        path="/class/:classId/attendance"
        element={
          isAttendanceFeatureEnabled()
            ? <StudentAttendancePage />
            : <Navigate to="/" replace />
        }
      />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/join-class" element={<JoinClassPage />} />
      <Route path="/supervisor/invite" element={<InviteSupervisorPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </>
);

export default StudentRouter;
